import React from "react";
import { Link } from "react-router-dom";
import "./DonationCancelled.css";

const DonationCancelled = () => {

    return (

        <main className="donation-cancelled-page">

            <div className="donation-cancelled-card">

                <div className="cancelled-icon">
                    ×
                </div>

                <div className="cancelled-eyebrow">
                    DONATION CANCELLED
                </div>

                <h1>
                    Your Donation Was Not Completed
                </h1>

                <p>
                    No payment was completed.
                    You can return to the donation page
                    and try again whenever you're ready.
                </p>

                <div className="cancelled-buttons">

                    <Link
                        to="/donate"
                        className="try-again-button"
                    >
                        Try Again
                    </Link>

                    <Link
                        to="/"
                        className="cancelled-home-button"
                    >
                        Return Home
                    </Link>

                </div>

            </div>

        </main>

    );
};

export default DonationCancelled;